import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ahaApi from "../../../app/services/aha-api";

const initialState = {
  value: [],
  loading: false,
};

export const updateHospital = createAsyncThunk(
  "hospitals/updateHospital",
  async (data, { rejectWithValue }) => {
    const response = await ahaApi.Account.updateHospital(data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return rejectWithValue(err.response.data);
      });

    return response;
  }
);

export const updateHospitalSLice = createSlice({
  name: "updateHospital",
  initialState,
  reducers: {
    clearUpdateHospitalResponse(state, action) {
      state.value = {}
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateHospital.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateHospital.fulfilled, (state, action) => {
        state.loading = false;
        state.value = action.payload;
      })
      .addCase(updateHospital.rejected, (state, err) => {
        state.loading = false;
        state.value = err.payload;
      });
  },
});

export const updateHospitalList = (state) => state.updateHospital.value;
export const updateHospitalLoader = (state) => state.updateHospital.loading;
export const {clearUpdateHospitalResponse} = updateHospitalSLice.actions;

export default updateHospitalSLice.reducer;
